import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Drawer, useDrawerState, ApplicationUIContext } from '@yuhuinc/ui-library';
import { Form, Typography, Button } from 'antd';

import AssignAdditionalApplicant from '../assign_additional_applicant';
import AdditionalApplicantsTable from './AdditionalApplicantsTable';

import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

const SelectAdditionalApplicantsForm = ({
  siteAndProperties,
  loadingSiteAndProperties,
  applicationTemplates,
}) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [, assignAdditionalApplicantDrawer] = useDrawerState(false);

  const additionalApplicantsTitleText = getTranslatedString(
    'landlordPortal.applicationManagement.inviteLeadToApply.additionalApplicants'
  );

  return (
    <>
      <Title level={isMobile ? 4 : 5}>{additionalApplicantsTitleText}</Title>

      <Form.List name="additional_applicants">
        {(fields, operations) => {
          const onAddAdditionalApplicant = (additionalApplicant) =>
            operations.add(additionalApplicant);

          return (
            <>
              {fields.length > 0 && (
                <AdditionalApplicantsTable
                  siteAndProperties={siteAndProperties}
                  applicationTemplates={applicationTemplates}
                  applicants={fields}
                  operations={operations}
                />
              )}

              <Button size={isMobile && 'large'} onClick={assignAdditionalApplicantDrawer.open}>
                {getTranslatedString(
                  'landlordPortal.applicationManagement.inviteLeadToApply.addAdditionalApplicant'
                )}
              </Button>

              <Drawer
                title={getTranslatedString(
                  'landlordPortal.applicationManagement.inviteLeadToApply.additionalApplicantDrawerTitle'
                )}
                visible={assignAdditionalApplicantDrawer.isVisible}
                closable
                destroyOnClose
                onClose={assignAdditionalApplicantDrawer.close}
              >
                <AssignAdditionalApplicant
                  siteAndProperties={siteAndProperties}
                  loadingSiteAndProperties={loadingSiteAndProperties}
                  closeDrawer={assignAdditionalApplicantDrawer.close}
                  onAdd={onAddAdditionalApplicant}
                />
              </Drawer>
            </>
          );
        }}
      </Form.List>
    </>
  );
};

SelectAdditionalApplicantsForm.propTypes = {
  siteAndProperties: PropTypes.array,
  loadingSiteAndProperties: PropTypes.bool,
};

SelectAdditionalApplicantsForm.defaultProps = {
  siteAndProperties: [],
  loadingSiteAndProperties: false,
};

export default SelectAdditionalApplicantsForm;
